const isMainNavEnabled = false;

export default [
  {
    path: "apphome",
    name: "App Home",
    component: () => import("../views/overview.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    //redirect: "helloworld",
  },{
    path: "unauthorized",
    name: "Unauthorized",
    component: () => import("../views/Unauthorized.vue"),
    meta: { mainNavEnabled: false, },
    //redirect: "helloworld",
  },
  {
    path: "vendormanagement",
    name: "Vendor Management",
    component: () => import("../views/AdminVendorManagement.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "usermanagement",
    name: "User Management",
    component: () => import("../views/AdminUserManagement.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  }, 
  {
    path: "edittemplate",
    name: "Edit Template",
    component: () => import("../views/AdminEditTemplate.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "allmysurveys",
    name: "All My surveys",
    component: () => import("../views/AllMySurveys.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "survey",
    name: "Survey",
    component: () => import("../views/Survey.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    props: true
  },
  {
    path: "survey/:id",
    name: "Survey",
    component: () => import("../views/Survey.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    props: true
  },   
  {
    path: "surveydetails/:id",
    name: "Survey Details",
    component: () => import("../views/SurveyDetails.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    props: true
  },
  {
    path: "surveytracking",
    name: "Survey Tracking",
    component: () => import("../views/CMAllSurveys.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "editsurvey/:id",
    name: "Edit Survey",
    component: () => import("../views/CMSurveyEdit.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    props: true
  }, 
  {
    path: "createnewsurvey",
    name: "Create New Survey",
    component: () => import("../views/CMCreateNewSurvey.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  }, 
  {
    path: "viewsurveyrating/:id",
    name: "Survey Ratings",
    component: () => import("../views/CMSurveyRatingView.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
    props: true
  },
   
  /*{
    path: "managevendors",
    name: "Manage Vendors",
    component: () => import("../views/ManageVendors.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },  
  {
    path: "allsurveytemplates",
    name: "All Survey Templates",
    component: () => import("../views/AllSurveyTemplates.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "assignsurveys",
    name: "Assign Surveys",
    component: () => import("../views/AssignSurveys.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "editsurveytemplate",
    name: "Edit Survey Template",
    component: () => import("../views/EditSurveyTemplate.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },  
  {
    path: "allsurveys",
    name: "All Surveys",
    component: () => import("../views/AllSurveys.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },
  {
    path: "updatesurveydetails",
    name: "Update Survey Details",
    component: () => import("../views/UpdateSurveyDetails.vue"),
    meta: { mainNavEnabled: isMainNavEnabled, },
  },*/
];
